import React, { FC } from 'react';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';
import { checkIsNative } from '@webtrader/core/validators/device';

import NavigationHeader from '@/components/Navigation/Header';
import Text from '@/components/Text';

interface IProps {
  title?: string;
}

const AuthScreenHeader: FC<IProps> = (props) => {
  const { title } = props;

  return (
    <Header>
      <NavigationHeader />
      {title && <HeaderTitle testID={EDataTestId.SCREEN_HEADER_TITLE}>{title}</HeaderTitle>}
    </Header>
  );
};

export default AuthScreenHeader;

const Header = styled.View`
  padding: ${dynamicSize.convertSize(4)}px 0;
`;

const HeaderTitle = styled(Text)`
  text-align: ${() => (checkIsNative() ? 'left' : 'start')};

  font-size: ${dynamicSize.convertSize(21)}px;
  font-weight: 500;
`;
